import MailSwipeAction from 'owa-service/lib/contract/MailSwipeAction';
import { action } from 'satcheljs';

/**
 * action for mutating the activeViewState in options store when the quick action option is changed along with side effects if any
 * @param newSwipeAction - the new value for the mail swipe action
 * @param isLeft - boolean which indicates if it is for the left swipe or not ( which means right swipe )
 * public action
 */
const changeQuickActionsOption = action(
    'changeQuickActionsOption',
    (newSwipeAction: MailSwipeAction, isLeft: boolean) => ({
        newSwipeAction,
        isLeft,
    })
);

export default changeQuickActionsOption;
